import ModalTableReplacement from "./modal-table-replacement";

export default ModalTableReplacement;